/**
 * Personalization name field toggle
 * Shows/requires the "Personalisierter Name" line item property
 * only when the customer selects the "mit Name" variant option.
 * Scoped to product handle: first-class-26-t-shirt
 */
(function () {
  var PROPERTY_LABEL = 'Personalisierter Name';
  var TRIGGER_VALUE = 'mit Name';

  function applyState(form) {
    var variantScript = form.querySelector('script[data-variant]');
    var propertyField = form.querySelector('[name="properties[' + PROPERTY_LABEL + ']"]');

    if (!variantScript || !propertyField) return;

    var wrapper = propertyField.closest('.product-form__line-item-property');
    var variant;

    try {
      variant = JSON.parse(variantScript.textContent);
    } catch (e) {
      return;
    }

    var isPersonalized = !!(variant && variant.title && variant.title.indexOf(TRIGGER_VALUE) !== -1);

    if (isPersonalized) {
      if (wrapper) wrapper.hidden = false;
      propertyField.disabled = false;
      propertyField.required = true;
    } else {
      if (wrapper) wrapper.hidden = true;
      propertyField.required = false;
      propertyField.disabled = true;
      propertyField.value = '';
    }
  }

  function initAll() {
    document.querySelectorAll('variant-picker').forEach(function (picker) {
      var form = picker.closest('.product-form');
      if (!form) return;

      var variantScript = form.querySelector('script[data-variant]');
      if (!variantScript) return;

      applyState(form);

      var observer = new MutationObserver(function () {
        applyState(form);
      });

      observer.observe(variantScript, { childList: true, characterData: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
